import { defineComponent as _defineComponent } from 'vue'
import LoginChoose from '@/components/layout/loginPopup/LoginChoose.vue';

import { onUnmounted, shallowRef } from "vue";
import dataService from '@/services/data.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPopUp',
  props: {
  showAddressOption: {
    type: Boolean,
    default: true,
    required: false
  }
},
  emits: ['close', 'typeChange', 'connected'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

document.body.style.overflow = "hidden";
onUnmounted(() => {
  document.body.style.overflow = "auto";
});

const emit = __emit;

const loginType = shallowRef(LoginChoose);

function keplrConnect(){
  dataService.onKeplrLogIn(() => {emit('close');emit('connected');});
  // useUserStore().connectKeplr().then(() => {
  //   if (useUserStore().isLoggedIn){
  //     emit('close')
  //   } else {
  //     return
  //   }
  // });
}
function cosmostationConnect() {
  dataService.onCosmostationLogIn(() => {emit('close');emit('connected');});
}

const leapConnect = () => {
  dataService.onLeapLogIn(() => {emit('close');emit('connected');});
};


const __returned__ = { props, emit, loginType, keplrConnect, cosmostationConnect, leapConnect, LoginChoose }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})